import { createContext, useContext } from "react";

import type { BoundingBox, Point } from "../types.ts";
import { type BoundRestriction } from "./DimensionsContext.ts";

export const restrictPointToBounds = (point: Point, bounds: BoundRestriction): Point => {
  const { minX, minY, maxX, maxY } = bounds;
  return {
    x: point.x > maxX ? maxX : point.x < minX ? minX : point.x,
    y: point.y > maxY ? maxY : point.y < minY ? minY : point.y,
  };
};

type ConversionContext = {
  clientToMap: (clientCoords: Point) => Point;
  mapBounds: BoundingBox;
};

export const ConversionContext = createContext<ConversionContext | undefined>(undefined);
ConversionContext.displayName = "ConversionContext";

export const useConversion = () => {
  const conversionContext = useContext(ConversionContext);
  if (!conversionContext) {
    throw new Error(`Expected ConversionContext in component tree.`);
  }
  return conversionContext;
};
